export function getStorage(key) {
  try {
    const data = JSON.parse(window.localStorage.getItem(key));
    return data;
  } catch (err) {
    return null;
  }
}

export function getStorageItem(key, itemKey, value) {
  const data = getStorage(key);
  if (data) {
    return data.find(item => item[itemKey] === value);
  }
  return null;
}

export function setStorage(key, data) {
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {

  }
}

export function setStorageItem(key, itemKey, oldItemKeyValue, newItemValue) {
  try {
    let data = getStorage(key);
    // 如果没有数据
    if (!data) {
      data = [];
      data.push(newItemValue);
    } else {
      // 如果没有找到旧数据
      let isSetOk = false;
      const temp = data;
      data.forEach((v, k) => {
        console.log(v[itemKey], oldItemKeyValue);
        if (v[itemKey] === oldItemKeyValue) {
          temp[k] = newItemValue;
          isSetOk = true;
        }
      });
      data = temp;
      if (!isSetOk) {
        data.push(newItemValue);
      }
    }
    setStorage(key, JSON.stringify(data));
  } catch (e) {

  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js